import type { Deal } from '../../../types/Deal';
import { WidgetId } from '../../../types/Widget';
import type { WidgetProps } from '../../../types/WidgetProps';
import type Localiser from '../../Localiser';

import getInbodyLabel from './getInbodyLabel';

export default (
  localiser: Localiser,
  widget: WidgetProps['widget'],
  deal: Deal,
  linkText: string,
  showPrice: string,
): string => {
  switch (widget.id) {
    case WidgetId.BUTTON:
      if (deal?.product_type && deal.product_type !== 200) {
        return localiser.translate('checkPriceLinkText');
      }
      return '';
    case WidgetId.MERCHANT_LINK:
      if (showPrice === 'noPrice') {
        return '';
      }
      if (deal?.offer && deal?.product_type && deal.product_type === 3500) {
        if (showPrice === 'stream') {
          if (deal.offer?.price && Number(deal.offer.price) > 0) {
            return (
              deal.merchant &&
              localiser.translate('multimediaStreamOn', [String(deal.merchant.name)])
            );
          }
          return (
            deal.merchant &&
            localiser.translate('multimediaStreamOnWithoutFor', [String(deal.merchant.name)])
          );
        }
        if (showPrice === 'availableToStream') {
          return (
            deal.merchant &&
            localiser.translate('multimediaAvailableToStream', [String(deal.merchant.name)])
          );
        }
      }
      if (
        deal?.offer &&
        ((deal?.product_type && deal.product_type === 200) || !deal?.offer?.price)
      ) {
        return `${localiser.translate('merchantLinkWidgetItemBuySimilarLabel')} ${
          deal?.merchant?.name || 'merchant'
        }`;
      }
      return (
        deal?.merchant && localiser.translate('priceLinkAtMerchant', [String(deal.merchant.name)])
      );
    case WidgetId.STREAMING:
      if (showPrice === 'noPrice') {
        return '';
      }
      if (
        deal?.offer &&
        deal?.product_type &&
        (deal.product_type === 3500 || deal.product_type === 2500)
      ) {
        return (
          deal?.merchant &&
          localiser.translate('multimediaWatchAtWithoutFor', [String(deal.merchant.name)])
        );
      }
      if (deal?.offer && deal?.product_type && (deal.product_type === 200 || !deal?.offer?.price)) {
        return `${localiser.translate('merchantLinkWidgetItemBuySimilarLabel')} ${
          deal?.merchant?.name || 'merchant'
        }`;
      }
      return (
        deal?.merchant && localiser.translate('priceLinkAtMerchant', [String(deal.merchant.name)])
      );
    case WidgetId.INBODY:
      return getInbodyLabel(
        deal,
        linkText,
        localiser.language,
        localiser.translate.bind(localiser),
      );
    case WidgetId.PRODUCT_BLOCK:
      return localiser.translate('shopNow');
    default:
      return '';
  }
};
